import { Button, Center, Grid, GridItem, Skeleton, Stack, Text, useBoolean } from "@chakra-ui/react"
import React, { useEffect, useState } from "react"
import { RiRestartLine } from "react-icons/ri"

import GeneratorsApi from "@shared/api/generators"
import { errorsStr } from "@shared/resourses/strings"
import CopiedButton from "@shared/ui/copied-button"

interface PasswordAndSecret {
  password_alphanum: string[]
  password_strong: string[]
  wep_16: string[]
  wep_32: string[]
  wep_64: string[]
}

const PasswordAndSecret = () => {
  const [secrets, setSecrets] = useState<PasswordAndSecret | null>(null)
  const [errorInfo, setErrorInfo] = useState<string>("")
  const [needReload, controlNeedReload] = useBoolean(false)

  useEffect(() => {
    if (!secrets) {
      GeneratorsApi.makePasswordAndSecretHandler().then(({ result }) => {
        if (result) {
          setSecrets(result)
        } else {
          setErrorInfo(errorsStr.SOMETHING_WENT_WRONG)
        }
      })
    }
  }, [secrets])

  useEffect(() => {
    if (needReload) {
      GeneratorsApi.makePasswordAndSecretHandler().then(({ result }) => {
        if (result) {
          setSecrets(result)
        } else {
          setErrorInfo(errorsStr.SOMETHING_WENT_WRONG)
        }
      })
      controlNeedReload.off()
    }
  }, [needReload, controlNeedReload])

  return !secrets ? (
    <Skeleton flex={"1"} h={"10"} />
  ) : (
    <Stack>
      <Grid templateColumns={"repeat(1, 1fr)"} gap={6}>
        {errorInfo && (
          <GridItem colSpan={2}>
            <Center>
              <Text fontWeight={"bold"}>{errorInfo}</Text>
            </Center>
          </GridItem>
        )}
        <GridItem>
          <Button gap={"3"} variant="outline" onClick={controlNeedReload.on}>
            Generate <RiRestartLine />
          </Button>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            Alphanumeric
          </Text>
          <Grid templateColumns={{ md: "repeat(3, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {secrets.password_alphanum.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            Strong
          </Text>
          <Grid templateColumns={{ md: "repeat(3, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {secrets.password_strong.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            64-bit Hex
          </Text>
          <Grid templateColumns={{ md: "repeat(3, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {secrets.wep_16.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            126-bit Hex
          </Text>
          <Grid templateColumns={{ md: "repeat(2, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {secrets.wep_32.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
        <GridItem>
          <Text color={"cyan.600"} fontWeight={"bold"}>
            256-bit Hex
          </Text>
          <Grid templateColumns={{ md: "repeat(2, 1fr)", base: "repeat(1, 1fr)" }} gap={4}>
            {secrets.wep_64.map((value) => (
              <CopiedButton key={value} value={value} />
            ))}
          </Grid>
        </GridItem>
      </Grid>
    </Stack>
  )
}

export default PasswordAndSecret
